<template>
    <div class="font-poppin">
        <div class="filter-header header-filterbgcolor">
            <div class="fs-14 font-weight-bold ml-4">Filters (<span style="color:#ffba00 !important;">{{totalFilters}}</span>)</div>
            <div class="pointer">
                <span @click="closeFilters()">
                    <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ArrowBgBlue.svg" alt="arrow">
                </span>
                <span @click="resetFilter()">
                    <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ResetBgBlue.svg" alt="reset">
                </span>
                <span @click="closeFilters()">
                    <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/CloseBgBlue.svg" alt="close">
                </span>
            </div>
        </div>
        <div class="container filter-contents">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtermodal font-weight-bold title-drop">Deal Name</span>
                        <multiselect label="deal_name" :limit="1" :limit-text="limitDealName" @search-change="searchDeal(deal_name_options)" placeholder="Select Deal Name" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="deal_name" :options="deal_name_options" :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" @close="update()">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.deal_name}}</span>
                                    <span class="custom__remove pointer" @click="removeDealName(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfDeals" />
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold" >Deal Name Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtermodal font-weight-bold title-drop">Deal Owner Name</span>
                        <multiselect label="deal_owner" :limit="1" :limit-text="limitDealOwner"  @search-change="searchDeal(deal_name_options)" placeholder="Select Deal Owner" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="deal_owner" :options="deal_name_options" :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" @close="update()">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.deal_owner }}</span>
                                    <span class="custom__remove pointer" @click="removeDealOwner(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold" >Deal Owner Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtermodal font-weight-bold title-drop">Pipeline Name</span>
                        <multiselect @search-change="searchDeal" :limit="1" placeholder="Select Range" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="pipeline_amount" :options="deal_name_options" :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.pipeline_name }}</span>
                                    <span class="custom__remove pointer" @click="removePipelineAmount(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfDeals" />
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold" ></div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600"></div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtermodal font-weight-bold title-drop">Deal Price ({{currency}})</span>
                        <el-range
                            v-model="deal_price"
                            placeholder="Select Date"
                            class="w-100 filter-date mt-2"
                            >
                        </el-range>
                        <el-number-range v-model="deal_price" class="w-100 mt-2" />
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventBus/nav-bar-event';
import salesforecast from "../mixins/salesforecast";
export default {
    props:['sales_forecast_details',"status"],
    data() {
        return {
            deal_owner: [],
            pipeline_amount: null,
            deal_price: null,
            target_increment: null,
            deal_name: [],
            deal_name_options: [],
            deal_name_count: 0,
            deal_name_loading:false,
            deal_name_scrollable :false,
            deal_name_visible: false,
            temp_deals: [],
            limit: 10,
            currency:'',
            //deal_id:[]
        }
    },
    mixins:[salesforecast],
    methods: {
        closeFilters(){
            this.$emit('hideFilters')
        },
        async searchDeal(search,data){
            let params = {
                sales_forecast_id: this.$route.params.id,
                product_id: this.sales_forecast_details.product_id,
                status: this.status,
                search_key: search
            }
            let response = await this.listSalesForeCastDeals(params)
            this.deal_name_options = response.response
            this.deal_name_options = this.deal_name_options.filter((thing, index) => {
                const payload = JSON.stringify(thing);
                return index === this.deal_name_options.findIndex(obj => {
                    return JSON.stringify(obj) === payload;
                });
            });
            
            
            this.deal_name_count = response.response.length;
            this.deal_name_loading = false
            this.deal_name_scrollable = false
        },
        async reachedEndOfDeals(reached){
            this.deal_name_visible = reached
            
            if (reached) {
                if (this.deal_name_scrollable == false) {
                    this.deal_name_loading = true
                    let params = {
                        skip: this.deal_name_count,
                        limit: this.limit,
                        sales_forecast_id: this.$route.params.id,
                        product_id: this.sales_forecast_details.product_id,
                        status: this.status
                    }
                    let response = await this.listSalesForeCastDeals(params)
                    this.temp_deals = response.response.length;
                    if (response.skip == this.deal_name_count) {
                        if (this.temp_deals > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.deal_name_options.push(el);
                            });
                            this.deal_name_options = this.deal_name_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.deal_name_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.deal_name_count += response.response.length;
                            this.deal_name_loading = false
                        } else {
                            this.deal_name_scrollable = true
                            this.deal_name_loading = false
                        }
                    }
                    this.deal_name_loading = false
                }
            }
        },
        limitDealName(count) {
			return `+ ${count} more`
        },
        limitDealOwner(count){
            return `+ ${count} more`
        },
        closeFilters(){
            this.hide_filters = false
            this.deal_name_count = 0
            this.deal_name_scrollable = false
            this.deal_name_visible = false
            this.$emit('hideFilters')
        },
        resetFilter(){
            if(this.totalFilters > 0){
                this.deal_name = []
                this.deal_owner = []
                this.update()
            }
        },
        removeDealName(option){
            this.deal_name.forEach((el,index)=>{
                if(el._id == option._id){
                    this.deal_name.splice(index,1)
                }
            })
        },
        removeDealOwner(option){
            this.deal_owner.forEach((el,index)=>{
                if(el == option){
                    this.deal_owner.splice(index,1)
                }
            })
        },
        update(){
            this.deal_name_count = 0
            this.deal_name_loading = false
            this.deal_name_scrollable = false
            this.temp_deals = []
            this.deal_name_visible = false
            let params = {
                deal_name:this.deal_name.map(x =>{return x.deal_id}),
                deal_owner:this.deal_owner.map(x => {return x.owner_id})
            }
            let newData = {
                value:params,
            }
            this.$emit('UpdateByFilter',newData)
        },
    },
    mounted(){
        this.currency = this.loggedInUser.currency.symbol;
        EventBus.$on('removechip',params=>{
            if(params.key == 'deal_name'){
                this.removeDealName(params.value)
                this.update()
            }else if(params.key == 'deal_owner'){
                this.removeDealOwner(params.value)
                this.update()
            }
        })
        EventBus.$on('removeAllchip',() => {
            this.resetFilter()
        })
    },
    computed:{
        totalFilters(){
            return this.deal_name.length + this.deal_owner.length
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        }
    }
}
</script>

<style scoped>
    .header-filterbgcolor {
        background-color: #0000cd !important;
    }
    .title-drop {
        color: #0d84f2;
    }
    .filter-contents {
        max-height: 500px !important;
        overflow-x: auto !important;
        overflow-y: auto !important;
    }
    .text-filtermodal {
        color: #0d84f2;
    }
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/ModalFilterData.vue